import React from 'react';
import { calculateDatesFromType } from '../../utils/dates';
import { AdsQueryVariables } from './useAdsAnalyticsParams';

interface UseAdsDateDefaultsProps {
  clientCreatedDate?: string;
  defaultVariables: Omit<AdsQueryVariables, 'clientId'>;
}

export const useAdsDateDefaults = ({ clientCreatedDate, defaultVariables }: UseAdsDateDefaultsProps) => {
  // Get default dates for initialization
  const getDefaultDates = React.useCallback(() => {
    const minDate = clientCreatedDate ? new Date(clientCreatedDate) : undefined;
    if (minDate) {
      minDate.setUTCHours(0, 0, 0, 0);
    }
    const dates = calculateDatesFromType(defaultVariables.dateType, minDate);
    return {
      startDate: dates.startDate.toISOString().split('T')[0],
      endDate: dates.endDate.toISOString().split('T')[0],
    };
  }, [clientCreatedDate, defaultVariables.dateType]);

  // Use default variables with computed dates for fallback
  const defaultVariablesWithDates = React.useMemo(() => {
    const dates = getDefaultDates();
    return {
      ...defaultVariables,
      startDate: dates.startDate,
      endDate: dates.endDate,
    };
  }, [getDefaultDates, defaultVariables]);

  return {
    getDefaultDates,
    defaultVariablesWithDates,
  };
};
